export enum HttpStatusCodes {
    Unauthorized = 401,
    NotFound = 404,
    Gone = 410,
    BadRequest = 400,
    InternalError = 500
}
